import {api} from '../../helpers';
import {getCookieValue} from '../../helpers/getCookie';
const type = 'authenticate';
const env = getCookieValue('env');
const environment = env?.toLowerCase();

function fetchAuthWidgets(params) {
  return api
    .get('/users/widget/kyc', {params: {...params, type}})
    .then(res => res.data);
}
function fetchAuthWidget(id) {
  return api
    .get(`/users/widget/kyc/${id}`, {params: {type}})
    .then(res => res.data);
}
function createAuthWidget(data) {
  return api.post('/users/widget/kyc', {...data, type}).then(res => res.data);
}

function updateAuthWidget({id, data}) {
  return api
    .put(`/users/widget/kyc/${id}`, {...data, type})
    .then(res => res.data);
}

function previewAuthWidget(id) {
  return api
    .get(`/users/widget/kyc/${id}/preview`, {params: {type}})
    .then(res => res.data);
}

function fetchAuthentications(params) {
  return api
    .get('/users/kyc-dashboard/authentication', {
      params: {...params, environment},
    })
    .then(res => res.data);
}
function fetchAuthenticationDetails({authenticationId, type}) {
  return api
    .get(`/users/kyc-dashboard/authentication/${authenticationId}/${type}`)
    .then(res => res.data);
}
function fetchAuthenticationActivity(authenticationId) {
  return api
    .get(`/users/kyc-dashboard/authentication/${authenticationId}/timeline`)
    .then(res => res.data);
}
function fetchAuthenticationCustomers(params) {
  return api
    .get(`/users/kyc-dashboard/authentication/customers`, {
      params: {...params, environment},
    })
    .then(res => res.data);
}
function fetchAuthenticationCustomersAnalytics(params) {
  return api
    .get(`/users/kyc-dashboard/authentication/customers/analysis`, {
      params: {...params, environment},
    })
    .then(res => res.data);
}

export {
  fetchAuthWidget,
  fetchAuthWidgets,
  createAuthWidget,
  updateAuthWidget,
  previewAuthWidget,
  fetchAuthentications,
  fetchAuthenticationDetails,
  fetchAuthenticationActivity,
  fetchAuthenticationCustomers,
  fetchAuthenticationCustomersAnalytics,
};
